<template>
  <div class="tour__overview-card">
    <div class="card__tour-list">
      <router-link
        tag="button"
        class="card__tour-button"
        v-for="tour in getTourList()"
        :key="tour.id"
        :to="`/${tour.id}`"
        :style="{borderColor: $route.path === `/${tour.id}` ? tour.primaryColor : hover === tour.id ? '#999999' :'transparent', color: $route.path === `/${tour.id}` ? tour.primaryColor : '#999999'}"
        @mouseenter="hover = tour.id"
        @mouseleave="hover = null"
      >{{tour.title}}</router-link>
      <div class="tour-list__placeholder"></div>
    </div>
    <div
      class="card__image"
      :style="{background: 'url(' + (isMobile || isTablet ? active.smallImage : active.image)  + ') top center / cover no-repeat'}"
    >
      <div
        class="card__gradient"
        :style="{backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0), ${hexToRgba(active.secondaryColor, 0.8)} 82%)`}"
      >
        <div class="card__slogan">{{active.slogan}}</div>
        <div class="card__content">
          <div
            class="card__button"
            :style="{backgroundColor: active.primaryColor}"
            @click="openDialog()"
          >Jetzt buchen</div>
          <div class="card__infos">
            <div class="card__info">
              <icon name="calendar" class="card__info-icon"></icon>
              <template v-if="dates && dates.length > 0">
                <template v-for="(date, index) in dates">
                  <div :key="index">{{date}}</div>
                  <div
                    :key="index + '1'"
                    class="card__info-separator"
                    v-if="dates.length - 1 !== index"
                  ></div>
                </template>
              </template>
              <template v-else>
                <div>nach Absprache</div>
              </template>
            </div>
            <div class="card__info">
              <icon name="map-pin" class="card__info-icon"></icon>
              <div>{{active.location}}</div>
            </div>
            <div class="card__info">
              <icon name="tag" class="card__info-icon"></icon>
              <div>ab {{active.price}} €</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Icon from "../../../core/components/icon/Icon";

export default {
  name: "TourOverviewCard",
  data: () => ({
    hover: null,
    isMobile: false,
    isTablet: false
  }),
  computed: {
    active() {
      return this.getTourList().find(
        tour => `/${tour.id}` === this.$route.path
      );
    },
    dates() {
      return this.active.dates && this.active.dates.map(date =>
        this.dateToString(date.start, date.end)
      );
    }
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 768;
      this.isTablet = window.innerWidth < 1024;
    },
    openDialog() {
      this.$emit("open-dialog");
    },
    dateToString(start, end) {
      moment.locale("de");
      const startDate = moment(start);
      const endDate = moment(end);
      return `${
        startDate.year() < endDate.year()
          ? startDate.format("DD. MMM YYYY")
          : startDate.month() < endDate.month()
          ? startDate.format("DD. MMM")
          : startDate.format("DD.")
      } - ${endDate.format("DD. MMM YYYY")}`;
    },
    hexToRgba(hex, opacity) {
      const color = "0x" + hex.substring(1);
      return (
        "rgba(" +
        [(color >> 16) & 255, (color >> 8) & 255, color & 255, opacity].join(
          ","
        ) +
        ")"
      );
    }
  },
  components: {
    Icon
  }
};
</script>

<style scoped lang="scss">
.tour__overview-card {
  position: relative;
  width: 1024px;
  min-height: 512px;
  border-radius: 16px;
  box-shadow: 0 0 28px -8px rgba(13, 13, 13, 0.1),
    0 56px 100px -56px rgba(13, 13, 13, 0.2);
  background-color: #ffffff;
  margin: 0 auto 60px;
  padding: 32px;
}

.card__tour-list {
  margin-bottom: 16px;
  display: flex;
  flex-direction: row;
}

.tour-list__placeholder {
  display: none;
  min-width: 48px;
}

.card__tour-button {
  border-radius: 4px;
  line-height: 16px;
  text-align: center;
  margin-right: 8px;
  padding: 0 8px;
  border-width: 0;
  //font-family: Soleil;
  font-family: Lato;
  font-size: 16px;
  letter-spacing: 0.2px;
  border-style: solid;
  border-width: 2px;
  display: flex;
  height: 32px;
  align-items: center;

  &.router-link-exact-active {
    font-weight: bold;
    //font-family: SoleilSb;
    font-family: Lato;
    font-weight: 700;
  }

  &.active {
    font-weight: bold;
    //font-family: SoleilSb;
    font-family: Lato;
    font-weight: 700;
  }

  &:hover,
  &:active,
  &:focus {
    border-style: solid;
    border-width: 2px;
    outline: none;
  }
}

.card__image {
  width: 960px;
  height: 400px;
  border-radius: 4px;
}

.card__gradient {
  border-radius: 4px;
  width: 100%;
  height: 100%;
  padding: 32px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.card__slogan {
  font-family: "Playfair Display";
  font-size: 40px;
  font-weight: 700;
  letter-spacing: 0.5px;
  color: #ffffff;
  text-align: left;
  margin-bottom: 24px;
  max-width: 700px;
}

.card__content {
  display: flex;
  flex-direction: row;
}

.card__infos {
  display: flex;
  flex-direction: row;
}

.card__button {
  border-radius: 4px;
  line-height: 20px;
  padding: 10px 24px;
  //font-family: Soleil;
  font-family: Lato;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.7px;
  color: #ffffff;
  text-transform: uppercase;
  margin-right: 16px;
  cursor: pointer;
  flex: 0 0 auto;
}

.card__info {
  border-radius: 4px;
  padding: 0 18px;
  min-height: 40px;
  color: #ffffff;
  margin-right: 16px;
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  background-color: rgba(247, 247, 247, 0.2);
  //font-family: SoleilLt;
  font-family: Lato;
  font-weight: 300;
  font-size: 16px;
  letter-spacing: 0.2px;
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #f7f7f7;

  &-icon {
    font-size: 16px;
    width: 16px;
    height: 16px;
    margin-right: 8px;
  }

  &-separator {
    width: 1px;
    height: 24px;
    background-color: #f7f7f7;
    margin: 0 8px;
  }
}

@media (max-width: 1023px) {
  .tour__overview-card {
    width: 100%;
    border-radius: 0;
    box-shadow: none;
    margin: 0 auto 60px;
    padding: 0;
  }

  .tour-list__placeholder {
    display: block;
  }

  .card__tour-list {
    padding: 24px 48px;
    margin: 0;
    overflow-x: scroll;
    background: #f0f0f0;

    &::after {
      content: "";
      position: absolute;
      right: 0;
      height: 54px;
      top: 0px;
      pointer-events: none;
      width: 100px;
      background-image: linear-gradient(
        to left,
        #f0f0f0,
        rgba(247, 247, 247, 0)
      );
    }
  }

  .card__image {
    width: 100%;
    height: 523px;
    border-radius: 0;
  }

  .card__gradient {
    border-radius: 0;
    padding: 0;
  }

  .card__slogan {
    padding: 0 48px;
    margin-bottom: 16px;
  }

  .card__content {
    flex-direction: column;
  }

  .card__infos {
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
    background-color: rgba(247, 247, 247, 0.2);
    height: 64px;
    padding: 0 48px;
  }

  .card__button {
    max-width: 170px;
    margin: 0 48px 24px;
  }

  .card__info {
    border-radius: 0;
    margin-right: 40px;
    backdrop-filter: none;
    background: none;
    padding: 0;

    &:last-of-type {
      margin-right: 0;
    }
  }
}

@media (max-width: 767px) {
  .card__tour-list {
    padding: 24px;

    &::before {
      width: 24px;
    }
  }

  .card__infos {
    flex-wrap: wrap;
    height: unset;
    padding: 16px 0 0 24px;
  }

  .card__info {
    margin: 0 40px 16px 0;
    min-height: unset;
  }

  .card__slogan {
    padding: 0 24px;
    font-size: 24px;
    letter-spacing: 0.3px;
  }

  .card__button {
    margin: 0 24px 24px;
  }
}
</style>
